import React, { FC, useEffect, useState } from 'react';

import { Checkbox, FormControlLabel } from '@material-ui/core';
import RadioButtonCheckedRoundedIcon from '@material-ui/icons/RadioButtonCheckedRounded';
import RadioButtonUncheckedRoundedIcon from '@material-ui/icons/RadioButtonUncheckedRounded';

import { IMetaFormat, TParScoreType } from '../../../../../../store/admin/roundFormats/store';

import Input from '../../../../../../components/Input';
import { ScoringFormatStyled } from './ScoringFormat.Styles';
import { scoreValues } from './Utils/scoreValues';

interface IProps {
  metaFormatToUpdate: IMetaFormat;
  onSaveMetaFormat: (format: IMetaFormat) => void;
}

const ScoringFormat: FC<IProps> = props => {
  const { metaFormatToUpdate, onSaveMetaFormat } = props;

  const [isStableFord, setIsStableFord] = useState(false);

  useEffect(() => {
    setIsStableFord(metaFormatToUpdate.scoringFormat === 1);
  }, [metaFormatToUpdate]);

  const toggleIsStableFord = () => {
    onSaveMetaFormat({ ...metaFormatToUpdate, scoringFormat: isStableFord ? 0 : 1 });
  };

  const [stablefordMetadata, setStableFordMetadata] = useState<Record<TParScoreType, number>>();

  useEffect(() => {
    if (
      metaFormatToUpdate &&
      metaFormatToUpdate.metadata &&
      metaFormatToUpdate.metadata.stableford
    ) {
      setStableFordMetadata(metaFormatToUpdate.metadata.stableford);
    }
  }, [metaFormatToUpdate]);

  const updateStableFordMetadata = (value: TParScoreType) => (evnt: any) => {
    if (
      metaFormatToUpdate &&
      metaFormatToUpdate.metadata &&
      metaFormatToUpdate.metadata.stableford
    ) {
      onSaveMetaFormat({
        ...metaFormatToUpdate,
        metadata: {
          ...metaFormatToUpdate.metadata,
          stableford: {
            ...metaFormatToUpdate.metadata.stableford,
            [value]: evnt.target.value
          }
        }
      });
    }
  };

  return (
    <ScoringFormatStyled>
      <div className="scoring-format">
        <p className="format-label">SCORING FORMAT</p>

        <div>
          <FormControlLabel
            className="round-subformat-checkbox override"
            classes={{ label: 'label' }}
            control={
              <Checkbox
                className="check-considered-flight"
                checked={!isStableFord}
                onChange={toggleIsStableFord}
                icon={<RadioButtonUncheckedRoundedIcon fontSize="large" />}
                checkedIcon={<RadioButtonCheckedRoundedIcon fontSize="large" />}
                value="on"
                color="primary"
              />
            }
            label="Standard"
          />

          <FormControlLabel
            className="round-subformat-checkbox override"
            classes={{ label: 'label' }}
            control={
              <Checkbox
                className="check-considered-flight"
                checked={isStableFord}
                onChange={toggleIsStableFord}
                icon={<RadioButtonUncheckedRoundedIcon fontSize="large" />}
                checkedIcon={<RadioButtonCheckedRoundedIcon fontSize="large" />}
                value="on"
                color="primary"
              />
            }
            label="Stableford"
          />
        </div>
      </div>

      {isStableFord && stablefordMetadata && (
        <div className="stableford-score-values">
          <p className="format-label">STABLEFORD SCORE VALUES</p>

          <div className="selectors-container">
            {scoreValues.map(scoreValue => (
              <div className="selector" key={`par-score-type-${scoreValue.name}`}>
                <p>{scoreValue.name}</p>

                <Input
                  label=""
                  type="number"
                  id={`score-type-input-${scoreValue.name}`}
                  outlined={false}
                  fullWidth={false}
                  noIcon={true}
                  multiline={false}
                  value={stablefordMetadata[scoreValue.value]}
                  onChange={updateStableFordMetadata(scoreValue.value)}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </ScoringFormatStyled>
  );
};

export default ScoringFormat;
